const $ = require('jquery');

$.fn.IACombobox = require('./Widgets/combobox');
$.fn.IATableCombobox = require('./Widgets/tableCombobox');
$.fn.IATypeahead = require('./Widgets/typeahead');
$.fn.IATableTypehead = require('./Widgets/tableTypeahead');
